import column from '../../abstract/column';
import form from '../../abstract/form.js';
import vars from '../../abstract/vars';
import actions from './actions';
import api, { modelName } from './api';

export default {
  actions,
  api,
  modelName,
  columns: {
    id: column({
      label: 'ID',
      grid: false,
    }),
    work_parameters_types_name: column({
      label: 'Opis',
      form: form({ required: true, disabled: true }),
    }),
    parameters: column({
      label: 'Parametry',
      sidebar: ({ item }) => item.parameters,
      form: form({ required: true, disabled: true }),
      format: item => {
        if(item.parameters === null) {
          return '-';
        }

        let output = '';

        for (const [key, value] of Object.entries(item.parameters)) {
          output += `${ key }: ${ value }`;
        }
        return output;
      },
    }),
  },
  vars: vars({
    noItemsText: 'Brak parametrów pracy',
    sidebarLabel: 'Podgląd parametru',
    onSuccessSave: async ({ $router }) => await $router.push({ name: 'admin-work-parameters' }),
  }),
};
